// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SmoothScrollController from "./smooth_scroll_controller.js"
application.register("smooth-scroll", SmoothScrollController)

import RemoteModalController from "./remote_modal_controller.js"
application.register("remote-modal", RemoteModalController)
